Customer.Users ||= {}

class Customer.Users.WebchatProfileView extends Backbone.View

  template: JST["backbone/templates/customer/users/webchat_profile"]

  className: 'social-profile'
  id: 'webchat-profile'

  events:
    'click .remove-profile-button': 'removeSocialUser'

  initialize: (socialUser) ->
    @socialUser = socialUser

  render: ->
    @$el.html(@template(socialUser: @socialUser))
    @

  removeSocialUser: ->
    @trigger('profile:remove-social-user', @socialUser)